export const ServiceUrl = {
  LOGIN_V2: {
    CHECK: "/v2/admin/check",
    CHECK_USERNAME: "/v1/admin/login",

    CHECK_MOBILE_NUMBER: "mob/v2/login/check",
    CHECK_MOBILE_PASSWORD: "mob/v2/login/check-password",
    FORGOT_PASS_GET_OTP: "mob/v2/login/forgot-pass-otp",
    UPDATE_NEW_PASSWORD: "mob/v2/login/update-new-pass",
    TERMS: "mob/v2/login/list-terms",
  },
  ADMIN: {
    SETTINGS: "v1/settings",
    LIST_ACADEMIC_YEARS: "v1/admin/academic_years/list-academic-years",
    LIST_BATCH: "v1/admin/settings/batch/list",
    COLLEGE_YEARS: "v1/admin/settings/batch/list-college-years",

    LIST_COMMUNITY: "v1/set/community",
    LIST_RELIGIONS: "v1/set/religions",
    LIST_COLLEGES: "/mob/v2/colleges",
    MAKE_API: "/mob/v2/api",

    LIST_SCHOLARSHIPS: "v1/set/scholarships",
  },
  SEMESTER_ADMISSION: {
    UPDATE_COMMUNITY: "mob/stu/v1/sem/admission/update-community",
    VIEW_PENDINGS: "mob/stu/v1/sem/admission/view-pending",
    APPLY_NOW: "mob/stu/v1/sem/admission/apply-promotion",
  },
  STUDENT_TRANSFER: {
    APPLY_TRANSFER_DATE: "mob/stu/v1/sem/admission/apply-transfer-date",
    SAVE_TRANSFER_FORM: "mob/stu/v1/sem/admission/save-transfer-form",
  },
  ACADEMIC: {
    LIST_ACADEMIC_YEARS: "v1/admin/academic_years/list-academic-years",
    LIST_COURSES: "v1/admin/courses/list-courses",
    LIST_COURSES_V2: "v1/set/list-courses", // New Course List based on v2 Department
  },
  MOB: {
    CHECK_USERNAME: "mob/v1/login",
    VERIFY_LOGIN_OTP: "mob/v1/verify_otp",
    SET_LOGIN_PASSWORD: "mob/v1/set_password",
    MY_TIME_TABLE: "mob/v1/timetable/my-time-table",
    CHECK_ATT_ENTERED: "mob/v1/timetable/check-att-entered",

    TIME_TABLE_FOR_SUBSTITUTE: "mob/v1/timetable/substitute-time-table",
    TIME_TABLE_FOR_SUBSTITUTE_EDIT:
      "mob/v1/timetable/substitute-time-table-edit",
    TIME_TABLE_FOR_SUBSTITUTE_HOD_EDIT:
      "mob/v1/timetable/substitute-time-table-edit-hod",
    MY_NOTIFICATION: "mob/v1/notification/notification-list",
    MY_NOTIFICATION_COUNT: "mob/v1/notification/notification-count",
    LEAVE_APPROVEL_COUNT: "mob/v1/leave/leave-approval-count",
    NOTIFICATION_DETAIL: "mob/v1/notification/notification-details",
    SEARCH_STUDENT: "mob/v1/students/search",
    SEARCH_STUDENT_FOR_ATTENDANCE: "mob/v1/students/search-for-attendance",
    SAVE_STUDENT_ATTENDANCE: "mob/v1/timetable/save",
    LIST_STUDENTS_ATTENDANCE: "mob/v1/timetable/list-attendance",
    LIST_COURSE_WISE_SUBJECTS: "mob/v1/timetable/list-subjects",
    DAY_VALUE_BY_DATE: "mob/v1/timetable/day-value",
    DAY_VALUE_BY_DATE_STU: "mob/stu/v2/timetable/day-value",
    CURRENT_SEM_DATE: "mob/v1/timetable/current-sem-date",
    DATE_MARKED_LIST: "mob/v1/timetable/marked-details-byday",
    LIST_LONG_ABSENTEE: "mob/v1/students/long-absentee",
    DASHBOARD_DAY_WISE_ATTENDANCE_REPORT: "mob/v1/dashboard/day-att-report",
    DASHBOARD_FEE_COLLECTION_COUNT: "mob/v1/dashboard/fee-collection-count",
    DASHBOARD_FEE_RECEIVED_AMOUNT: "mob/v1/dashboard/fee-received-amount",
    DEPARTMENT_TIMETABLE: "mob/v1/timetable/dept-timetable",
    LIST_DEPARTMENT_WISE_MARKED_ATTENDANCE: "mob/v1/timetable/get-marked",

    UPCOMING_DAY_ORDER: "v1/oa/dayorder/upcoming-day-order",

    CURRENT_BATCHES: "mob/v1/dashboard/current-batch",
    UPDATE_PASSWORD: "mob/v1/dashboard/update-pass",
    TIMETABLE_COURSE_TYPES: "mob/v1/timetable/course-types",
    LIST_DAY_ORDERS_BY_BATCHSEM: "mob/v1/timetable/day-order-dates",
    DELETE_TIMETABLE: "mob/v1/timetable/delete-timetable",
    CLASS_PENDING_FEES: "v1/admin/fees/reports/class-wise-pending",
    EMP_LEAVE_LIST: "mob/v1/emp-leave/list",
    EMP_HOLIDAY_LIST: "mob/v1/emp-leave/holiday-list",
    EMP_LEAVE_TYPES_LIST: "mob/v1/emp-leave/list-leave-types",
    EMP_LEAVE_SAVE: "mob/v1/emp-leave/save",
    EMP_LEAVE_UPDATE: "mob/v1/emp-leave/update",
    EMP_LEAVE_UPDATE_HOD: "mob/v1/emp-leave/update-hod",
    EMP_LEAVE_APPLY: "mob/v1/emp-leave/leave-update",
    EMP_LEAVE_APPROVAL: "mob/v1/emp-leave/approval",
    EMP_SUBSTITUTE_LEAVE_APPROVAL: "mob/v1/emp-leave/substitude-approval",
    EMP_SUBSTITUTE_PERMISSION_APPROVAL:
      "mob/v1/emp-permission/substitude-approval",
    EMP_SUBSTITUTE_ODPERMISSION_APPROVAL:
      "mob/v1/emp-permission/substitude-odapproval",
    EMPLOYEES_LEAVE_PERMISSION:
      "v1/admin/payroll/salary/permission_leave_count",
    LIST_BOOK: "mob/stu/v1/libraries/book-list",
    LIST_ITEM_CIRCULATION: "mob/stu/v1/libraries/circulation-list",
    ANNOUNCEMENT_COUNT: "mob/stu/v2/notification/list-count-circular",
    ANNOUNCEMENT_STAFF_COUNT: "mob/v1/notification/list-count-circular",
    EMP_PERMISSION_SAVE: "mob/v1/emp-permission/save",
    EMP_PERMISSION_LIST: "mob/v1/emp-permission/list",
    EMP_ODPERMISSION_SAVE: "mob/v1/emp-permission/save-od",
    EMP_ODPERMISSION_LIST: "mob/v1/emp-permission/list-od",
    SEARCH_HOSTEL_STUDENT_FOR_ATTENDANCE:
      "mob/v1/students/search-for-hostel-attendance",
    SAVE_HOSTEL_STUDENT_ATTENDANCE: "mob/v1/timetable/hostel-save",
    GET_HOSTEL_DETAILS: "mob/v1/hostel/get-hostel-details",
    LIST_HOSTEL_ATTENDANCE: "mob/v1/hostel/hostel-attendance-details",
    LIST_HOSTEL_ATTENDANCE_DAY: "mob/v1/hostel/hostel-attendance-view",
    LIST_HOSTEL_ATTENDANCE_DATES: "mob/v1/hostel/hostel-attendance-dates",
    MY_HOSTEL_MARKLIST: "mob/v1/hostel/my-hostel-attendance-marklist",

    GET_SERVICE_DETAILS: "mob/stu/v1/serviceorganization/get-serivce-details",
    SEARCH_SER_ORG_STUDENT_FOR_ATTENDANCE:
      "mob/stu/v1/serviceorganization/search-for-serviceorg-attendance",
    SAVE_SERVICE_ORG_STUDENT_ATTENDANCE:
      "mob/stu/v1/serviceorganization/serviceat-save",
    GET_SERVICE_MATCH_DETAILS:
      "mob/stu/v1/serviceorganization/get-serivce-match-details",
    LIST_SERVICE_MARKED_ATTENDANCE:
      "mob/stu/v1/serviceorganization/list-marked-att",
    LIST_SERVICE_ATTENDANCE: "mob/stu/v1/serviceorganization/list-ser-att",
    LIST_INTENAL_CIRUCULAR: "mob/v1/circular/list-internal-circular",
    LIST_EXTERNAL_CIRUCULAR: "mob/v1/circular/list-external-circular",
    EMP_LIST: "mob/v1/staff-profile/list",
    LIST_DEPARTMENT: "mob/v1/staff-profile/list-dept",
    LIST_DESIGNATIONS: "v1/admin/hrmgt/designation/list-data",
    LIST_STAFFS: "mob/v1/task/list-staffs",
    LIST_TASK_PRIORITIES: "mob/v1/task/list-task-priorities",
    LIST_TASK_CATEGORY: "mob/v1/task/list-task-categories",
    ADD_TASK: "mob/v1/task/add-task",
    EDIT_TASK: "mob/v1/task/edit-task",
    LIST_TASKS: "mob/v1/task/list-tasks",
    LIST_TASK_LOG: "mob/v1/task/list-task-log",
    UPDATE_TASK_RESPONSE: "mob/v1/task/update-task-response",
    EMP_LIST_ATTENDANCE: "mob/stu/v1/emp-leave/staff-attendance-list",
    LIST_SUMMARY: "mob/stu/v1/libraries/summary-list",
    ADD_CATEGORY: "mob/v1/task/add-category",
    EDIT_CATEGORY: "mob/v1/task/edit-category",
    LIST_STAFF_TEMPLATE: "v1/admin/util/template/list-all",

    EMP_PAYSLIP_LIST: "mob/v1/staff-profile/payslip",
    GET_GENERATE_PAYSLIP: "mob/v1/staff-profile/generate-payslip",

    LIST_ESTABLISHMENT: "mob/v1/establishment/list-establishment",
    ADD_ESTABLISHMENT: "mob/v1/establishment/add-establishment",

    //class monitoring from erp api
    LIST_EMPLOYEES: "v1/admin/hrmgt/employee/list_data",
    LIST_SUBJECT: "v1/admin/subjects/sub/list",
    TIMETABLE_ON_DATE: "v1/admin/attendance/today-time-table",
    CLASS_TAKEN_REPORT: "v1/admin/attendance/class-taken-report",

    //att hour
    LIST_HOUR_PER_DAY: "v1/admin/settings/hoursetup/list",
  },
  STUDENTS: {
    LOGIN: "mob/stu/v1/login/check",
    LIST_COLLEGES: "mob/stu/v1/login/college-list",
    CHECK_REGISTER_NO_EXIST: "mob/stu/v1/register/register-no",
    GET_OTP_FOR_PROFILE_UPDATE: "mob/stu/v1/register/get-otp",
    VERIFY_OTP_FOR_PROFILE_UPDATE: "mob/stu/v1/register/verify-otp",
    GET_PROFILE: "mob/stu/v1/register/profile",
    GET_OTP_FOR_EMAIL: "mob/stu/v1/register/get-mail-otp",
    VERIFY_EMAIL_OTP: "mob/stu/v1/register/verify-mail-otp",
    UPDATE_PROFILE_STEP_ONE: "mob/stu/v1/register/update-step-one",
    UPDATE_PROFILE_STEP_TWO: "mob/stu/v1/register/update-step-two",
    UPDATE_PROFILE_STEP_THREE: "mob/stu/v1/register/update-step-three",
    UPDATE_PROFILE_STEP_FOUR: "mob/stu/v1/register/update-step-four",
    MY_TIME_TABLE: "mob/stu/v2/timetable/my-time-table",
    MY_ATTENDANCE_APPROVED: "mob/stu/v1/sem/admission/attendance-approved",
    MY_NOTIFICATION: "mob/stu/v2/notification/notification-list",
    MY_NOTIFICATION_COUNT: "mob/stu/v2/notification/notification-count",
    NOTIFICATION_DETAIL: "mob/stu/v2/notification/notification-details",
    DAY_VALUE_BY_DATE: "mob/stu/v2/timetable/day-value",
    MY_ATTENDANCE_PERCENTAGE: "mob/stu/v2/timetable/att-percentage",
    MY_ATTENDANCE_ABSENT: "mob/stu/v2/timetable/my-absent-days",

    LIST_CURRENT_SUBJECTS: "mob/stu/v2/targetmark/list-current-subjects",
    SAVE_SUBJECT_TARGET_MARK: "mob/stu/v2/targetmark/save-subject-target-mark",
    LIST_TARGET_MARK: "mob/stu/v2/targetmark/list-target-mark",

    LIST_HOUR_PER_DAY: "mob/stu/v1/settings/hoursetup/list",

    MY_FEES: "mob/stu/v2/fees/my-fees",
    PAY_FEES: "mob/stu/v2/fees/pay",

    ONLINE_LIST: "mob/stu/v1/stupay/online-list",
    TRACK_PAYMENT: "mob/stu/v1/onlinepay/track-order-status",

    LIST_INTERNSHIP: "mob/stu/v1/internship/list",
    SAVE_INTERNSHIP: "mob/stu/v1/internship/save",
    UPDATE_INTERNSHIP: "mob/stu/v1/internship/update",
    REMOVE_INTERNSHIP: "mob/stu/v1/internship/delete",
    LIST_STUDENT_AWARD: "mob/stu/v1/stud-award/list",
    SAVE_STUDENT_AWARD: "mob/stu/v1/stud-award/save",
    UPDATE_STUDENT_AWARD: "mob/stu/v1/stud-award/update",
    REMOVE_STUDENT_AWARD: "mob/stu/v1/stud-award/delete",
    LIST_FEEDBACK_QUESTIONS:
      "mob/stu/v1/feedback/list-feedback-questions-and-options",
    LIST_FEEDBACK_OPTION: "mob/stu/v1/feedback/list-feedback-option",
    LIST_FEEDBACK_TITLE: "mob/stu/v1/feedback/list-feedback-title",
    SAVE_STUDENT_FEEDBACK: "mob/stu/v1/feedback/add-feedback-answer",
    GET_FEEDBACK_SUB: "mob/stu/v1/feedback/get",
    GET_FEEDBACK_AUDIENCE: "mob/stu/v1/feedback/audience",
    LIST_STUDENT_CERTIFICATES: "mob/stu/v1/util/stucert/list-all",
    GET_STUDENT_CERTIFICATE: "mob/stu/v1/util/stucert/get",
    CHECK_OPEN_PAYMENT_STUDENT_NO: "mob/stu/v1/open_payment/check-register-no",
    OPEN_PAYMENT_FEES: "mob/stu/v1/open_payment/open-fee-list",
    OPEN_PAYMENT_LINk: "mob/stu/v1/open_payment/pay",
    SAVE_CONVOCATION: "mob/stu/v1/convocation/save",
    LIST_CONVOCATION: "mob/stu/v1/convocation/list",
    LIST_PDF_CONVOCATION: "mob/stu/v1/convocation/list-pdf",
    LIST_ID_CARD: "mob/stu/v1/studentidcard/list",
    SAVE_IDCARD: "mob/stu/v1/studentidcard/save",
    // LIST_HALLTICKET: "mob/stu/v1/hallticket",
    // LIST_STU_HALLTICKET: "mob/stu/v1/hallticket/stu_list",
    LIST_HALLTICKET: "mob/stu/v1/hallticket/list",
    // LIST_STU_HALLTICKET: "mob/stu/v1/hallticket/list-pdf",
    LIST_PDF: "mob/v1/pdf",
    EXAM_FEE_SUBJECT_LIST: "mob/stu/v1/exam-fees/exam-fee-subject-list",
    EXAM_FEE_CONFIG_LIST: "mob/stu/v1/exam-fees/list-exam-fee-config",
    CHECK_EXAM_FEE_PAID: "mob/stu/v1/exam-fees/check-exam-fee-paid",
    EXAM_FEE_PAYMENT: "mob/stu/v1/exam-fees/exam-fee-payment",
    SAVE_FINE_AMOUNT: "mob/stu/v1/exam-fees/save-fine-amount",
    ORDER_STATUS: "mob/stu/v1/exam-fees/order-status",

    GET_FEE_RECEIPT_TEMPLATE: "mob/stu/v1/exam-fees/get-fee-receipt",
    PDF_PREVIEW: "mob/stu/v1/exam-fees/pdf-preview",

    EXAM_HTK_EXAMINATION_LIST:
      "mob/stu/v1/hallticket/list-exam-hallticket-examination",
    EXAM_HTK_STUDENTS_SUBJECT_LIST:
      "mob/stu/v1/hallticket/hallticket-students-subject-list",
    HALLTICKET_PDF_PREVIEW: "mob/stu/v1/hallticket/hallticket-pdf-preview",

    DOWNLOAD: {
      PAID_FEE_RECEIPT: "v1/oa/download/fee-receipt/",
      PAYMENT_ACKNOWLDGEMENT: "v1/oa/download/payment-acknowldgement/",
    },
    LIST_EXAM_RESULTS: "mob/stu/v1/exam-results/list",
    LIST_EXAM_RESULTS_PDF: "mob/stu/v1/exam-results/list-pdf",

    LIST_EXAM_RESULTS_DATA: "mob/stu/v1/exam-results/list-results",

    LIST_ELECTIVE: "mob/stu/v1/elective/list",
    SAVE_ELECTIVE: "mob/stu/v1/elective/save",
    LIST_SUBJECT_ELECTIVE: "mob/stu/v1/elective/listsubject",
    MY_ELECTIVE_SELECTION_LIST: "mob/stu/v1/elective/my-selection-list",

    LIST_SERVICE: "mob/stu/v1/serviceorganization/list",
    SAVE_SERVICE: "mob/stu/v1/serviceorganization/save",
    LIST_SERIVE_ORG: "mob/stu/v1/serviceorganization/listsubject",
    LIST_STUDENT_DATA: "mob/stu/v1/serviceorganization/liststudents",
    LIST_SERVICE_ORG: "mob/stu/v1/serviceorganization/listorganization",

    ONLINE_TRANSPORT_LIST: "mob/stu/v1/transport/online-list",
    SAVE_TRANSPORT_PREFERENCE: "mob/stu/v1/transport/save-preference",

    BIRTHDAY_WISH_TEMPLATE: "mob/stu/v1/register/birthday-wish-template",
    STAFF_BIRTHDAY_WISH_TEMPLATE:
      "mob/stu/v1/register/staff-birthday-wish-template",
  },
  REQUEST: {
    SERVICE_TYPE: "mob/stu/v1/service_request/list-request",
    ADD_REQUEST: "mob/stu/v1/service_request/add-request",
    LIST_REQUEST: "mob/stu/v1/service_request/service-list",
    LIST_REQUEST_STATUS: "mob/stu/v1/service_request/list-request-status",
    ADD_REQUEST_PAYMENT: "mob/stu/v1/service_request/add-service-payment",
  },
  UTILITIES: {
    LIST_STUDENT_CERTIFICATES: "v1/admin/util/stucert/list-all",
    GET_STUDENT_CERTIFICATE: "v1/admin/util/stucert/get",
    UPDATE_STUDENT_CERTIFICATE: "v1/admin/util/stucert/update",
    CREATE_STUDENT_CERTIFICATE: "v1/admin/util/stucert/save",
  },
  LESSON_PLANS: {
    LIST_LESSON_PLANS: "mob/v1/timetable/lesson-plans",
  },
  CONVOCATION: {
    PDF: "mob/v1/pdf",
  },
  EVENTS: {
    DEPARTMENT_LIST: "mob/v1/events/list-department",
    SAVE_REPORTS: "mob/v1/events/save",
    LIST: "mob/v1/events/list",
    UPDATE_REPORTS: "mob/v1/events/update",
    CLUB_LIST: "mob/v1/events/list-club",
  },
};
